import { render, staticRenderFns } from "./modalEditGroup.vue?vue&type=template&id=2a4d95a2&"
import script from "./modalEditGroup.vue?vue&type=script&lang=js&"
export * from "./modalEditGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports